export const MATCH_PLAY_FORMATS = [
  'GolfSixes',
  'Match',
  'MatchPlay',
  'RyderCup',
  'TeamMatch',
  'HeroCup'
]
export const STROKE_PLAY_FORMATS = ['StrokePlay', 'Stroke', 'Team']
